import React, { Fragment, useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import { get } from 'lodash';
import { PuffLoader } from 'react-spinners';

import Validator from 'components/Validator/Validator';
import Header from 'components/Header';
import Footer from 'components/Footer';
import MaskedInput from 'components/Form/MaskedInput';
import { Grid, Column } from 'components/Layout';
import { Button } from 'components/Button';
import { numberUnmask } from 'utils/unmask';

import {
  nextAction,
  checkPreviousAction,
} from 'actions/workflow';
import schema from './schema';

import style from './style.scss';

const Welcome = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const workflow = useSelector((state) => state.workflow);
  const [searchParams] = useSearchParams();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (get(workflow, ['data']) === undefined) {
      const key = searchParams.get('key');

      dispatch(checkPreviousAction({
        data: {},
        url: `/workflows/microbilt/${key}/checkin`,
        success: (response) => {
          const routeUrl = get(response, 'data.url');
          navigate(routeUrl);
        },
        fail: () => {
          navigate('/fsl/application', { replace: true });
        },
      }));
    }
  }, []);

  const handleSubmitForm = (e) => {
    e.preventDefault();
    const { validator: { values, validate } } = props;
    if (validate(schema).isValid) {
      const to = searchParams.get('to');
      const key = searchParams.get('key');
      let formData;
      if (to) {
        formData = {
          SsnLast4Digits: numberUnmask(values.ssn),
          to,
        };
      } else {
        formData = {
          SsnLast4Digits: numberUnmask(values.ssn),
        };
      }
      setIsLoading(true);
      dispatch(nextAction({
        data: formData,
        url: `/workflows/microbilt/${key}/next`,
        success: (response) => {
          const routeUrl = get(response, 'data.url');
          navigate(routeUrl);
          setIsLoading(false);
        },
        fail: () => {
          setIsLoading(false);
        },
      }));
    }
  };

  const handleInputChange = (event) => {
    const { validator: { onChangeHandler } } = props;
    onChangeHandler(event.target.name, event.target.value);
  };

  const { validator: { values, errors } } = props;

  return (
    <Fragment>
      <Header />
      {get(workflow, 'data.data.firstName') ? (
        <section className={cn('grid-container fluid section', style['borrowers-apply'])}>
          <div className="content">
            <h2>Welcome back, {get(workflow, 'data.data.firstName')}!</h2>
            <p>Please enter the last 4 of your SSN to verify your identity</p>
            <Grid className="grid-margin-x">
              <Column className="small-10 small-offset-1 large-4 large-offset-4">
                <MaskedInput
                  label="Last 4 Digits of Your SSN"
                  isMasked="9999"
                  name="ssn"
                  value={values.ssn}
                  onChange={handleInputChange}
                  isRequired
                  hasError={!!errors.ssn}
                  errorMessage={errors.ssn}
                  notification="To protect your identity and for security purposes please enter the last 4 digits of your Social Security Number."
                />
              </Column>
              <Column>
                <Button
                  className={cn('button large green', style.button)}
                  onClick={handleSubmitForm}
                  isLoading={isLoading}
                  isDisabled={values.ssn === undefined}
                >
                  Continue
                </Button>
              </Column>
            </Grid>
          </div>
        </section>
        ) : (
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 500 }}>
            <PuffLoader color="#3989E3" size={100} />
          </div>
        )
      }
      <Footer />
    </Fragment>
  );
};

Welcome.propTypes = {
  validator: PropTypes.object.isRequired,
};

export default Validator(schema)(Welcome);
